
import { defineComponent, reactive, toRefs } from 'vue';
import Overlay from '../../components/Overlay.vue';
import VChart from 'vue-echarts';

export default defineComponent({
  name: 'DashboardPendingEntryOrders',

  components: {
    Overlay,
    VChart,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    label: {
      type: Array as () => Array<string>,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const colors = [
      '#007bff',
      '#28a745',
      '#ffc107',
      '#17a2b8',
      '#6610f2',
      '#fd7e14',
      '#dc3545',
    ];
    const propsRef = toRefs(props);
    const state = reactive({
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          top: '5%',
          left: '5%',
          right: '2%',
          bottom: '5%',
        },
        xAxis: {
          type: 'category',
          data: propsRef.label,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: 'Ordens pendentes de entrada',
            type: 'bar',
            data: propsRef.value,
            label: {
              show: true,
              position: 'top',
            },
            itemStyle: {
              color: function (params) {
                return colors[params.dataIndex] || '#999697';
              },
            },
          },
        ],
      },
    });
    return { ...toRefs(state), colors };
  },
  computed: {
    defaultColor() {
      return '#999697';
    },
  },
});
